<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="简称" prop="areaName">
                <a-input v-model="queryParam.areaName" :maxLength="32" placeholder="请输入简称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="全称" prop="fullName">
                <a-input v-model="queryParam.fullName" :maxLength="32" placeholder="请输入全称" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="上级id" prop="parentId">
                  <a-input v-model="queryParam.parentId" oninput="value=value.replace(/[^\d]/g,'')" :maxLength="6" placeholder="请输入上级id" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="行政级别" prop="level">
                  <a-input v-model="queryParam.level" oninput="value=value.replace(/[^\d]/g,'')" :maxLength="1" placeholder="请输入行政级别" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="创建开始时间" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="创建结束时间" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />导出
        </a-button>
        <a-button type="primary" @click="handleJsonExport">
          <a-icon type="download" />导出JSON
        </a-button>
        <a-button type="dashed" @click="$refs.importLakala.importExcelHandleOpen()">
          <a-icon type="import" />导入拉卡拉
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <import-lakala ref="importLakala" @ok="getList"></import-lakala>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="areaId"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageArea, listArea, areaListTree} from '@/api/logistics'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import ImportLakala from './ImportLakala';
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Area',
  components: {
    CustomDictTag,
    ImportLakala
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        areaName: undefined,
        fullName: undefined,
        parentId: undefined,
        level: undefined,
        longitude: undefined,
        latitude: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'areaId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '简称',
          dataIndex: 'areaName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '全称',
          dataIndex: 'fullName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '上级id',
          dataIndex: 'parentId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '行政级别',
          dataIndex: 'level',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          ellipsis: true,
          align: 'center'
        },
        {
          title: '经度',
          dataIndex: 'longitude',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '纬度',
          dataIndex: 'latitude',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '拉卡拉code',
          dataIndex: 'lakalaCode',
          ellipsis: true,
          align: 'center'
        },
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return '共'+total+'条'
    },
    /** 查询省市区地区信息列表 */
    getList () {
      this.loading = true
      pageArea(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        areaName: undefined,
        fullName: undefined,
        parentId: undefined,
        level: undefined,
        longitude: undefined,
        latitude: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.areaId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const areaIds = row.areaId || this.ids
      if(row.areaId){
        this.ids = []
        this.ids.push(row.areaId)
      }
      this.$confirm({
        title: this.请输入确认删除所选中数据,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"areaId":id}))
          return delArea(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.请输入删除成功
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('sys/area/export',
            that.queryParam
            , `省市区地区信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleJsonExport () {
      areaListTree({}).then(response => {
        let data = JSON.stringify(response.data);
        const blob = new Blob([data], {type: "text/plain;charset=utf-8"});
        // 创建一个指向该Blob的URL
        const url = URL.createObjectURL(blob);
        // 创建一个a标签
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "city.json");
        document.body.appendChild(link);
        // 触发下载
        link.click();
        // 清理
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
    }
  }
}
</script>